import { FC, useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { setIsExpired, startTimer } from '../../store/verify.slice';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store/rootReducer';


interface IProps {
  initSec: number;
}

const Timer: FC<IProps> = ({ initSec }) => {
  const dispatch = useDispatch();
  const [min, setMin] = useState(initSec ? parseInt(String(initSec / 60)) : 5);
  const [sec, setSec] = useState(initSec ? initSec % 60 : 0);
  const [_isExpired, _setIsExpired] = useState(false);
  const time = useRef<any>(initSec || 300);
  const timerId = useRef<any>(null);
  const { t } = useTranslation();

    useEffect(()=> {
        timerId.current = setInterval(() => {
            time.current -= 1;
            setMin(parseInt(String(time.current / 60)));
            setSec(time.current % 60);
        }, 1000);  
        return () => clearInterval(timerId.current);
    }, []);

    useEffect(() => {
        if (time.current <= 0) {
            clearInterval(timerId.current);
            _setIsExpired(true);
        }
    }, [sec]);


    useEffect(()=> {
        dispatch(setIsExpired(_isExpired));
    }, [_isExpired]);


  return (
    <>
      {
        _isExpired
          ? t('student.student.column130')
          : `${min}:${sec < 10 ? `0${sec}` : sec}`
      }      
    </>
  );
};

export default Timer;
